var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',[[_c('JgBespokeCrash'),_c('JgBespokeDouble'),_c('JgBespokeMines'),_c('JgBespokeBoom'),_c('JgBespokeSlot'),_c('JgBespokeNovibet'),_c('JgBespokeEveri'),_c('JgBespokeBetmgm'),_c('JgBespokeFanduel'),_c('JgCatalogGames')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }